"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantiationService = void 0;
var dispose_tree_1 = require("@tencent/dispose-tree");
var graph_1 = require("./graph");
var descriptors_1 = require("./descriptors");
var typing_1 = require("./typing");
var instantiation_1 = require("./instantiation");
var service_collection_1 = require("./service-collection");
var proxy_value_1 = require("./proxy-value");
var instantiation_trace_1 = require("./instantiation-trace");
var dependency_resolver_1 = require("./dependency-resolver");
var service_identifier_1 = require("./service-identifier");
var hierarchy_1 = require("./hierarchy");
var loader_base_1 = require("./loader-base");
var error_messages_1 = require("../constants/error-messages");
var util_1 = require("./util");
var IS_SUPPORT_PROXY = typeof global.Proxy === 'function';
/**
* 依赖注入框架
*/
var InstantiationService = /** @class */ (function () {
    function InstantiationService(services, strict, parent) {
        if (services === void 0) { services = new service_collection_1.ServiceCollection(); }
        if (strict === void 0) { strict = false; }
        this.hookRegistry = new Map(); // 用于注册对应ID的hook函数
        this.commonHookList = []; // 用于注册通用Hook函数
        this.innerService = services;
        this.strictMode = strict;
        // 将框架自身的实例放入容器，框架本身可以被注入到其他模块，为其他模块提供框架的全部能力
        this.innerService.set(instantiation_1.IInstantiationService, this);
        this.hierarchyNode = new hierarchy_1.HierarchyNode(this);
        if (parent) {
            var parentHierarchyNode = parent.getHierarchyNode();
            // 链接父子关系
            hierarchy_1.HierarchyNode.linkParentAndChild(parentHierarchyNode, this.hierarchyNode);
        }
    }
    /**
     * 用于维护框架实例的拓扑结构节点, 通过该节点可以遍历拓扑结构
     */
    InstantiationService.prototype.getHierarchyNode = function () {
        return this.hierarchyNode;
    };
    /**
     * 创建子DI框架，框架支持父子级联，形成单向依赖解析关系
     * @param services 初始化子DI框架所用的容器
     */
    InstantiationService.prototype.createChild = function (services) {
        var childInstantiationService = new InstantiationService(services, this.strictMode, this);
        return childInstantiationService;
    };
    /**
     * 添加子节点到当前节点
     * @param instantiationService
     */
    InstantiationService.prototype.addChild = function (instantiationService) {
        hierarchy_1.HierarchyNode.linkParentAndChild(this.hierarchyNode, instantiationService.getHierarchyNode());
    };
    /**
     * 将当前节点链接到父节点
     * @param instantiationService
     */
    InstantiationService.prototype.attachToParent = function (instantiationService) {
        hierarchy_1.HierarchyNode.linkParentAndChild(instantiationService.getHierarchyNode(), this.hierarchyNode);
    };
    /**
     * 获取当前依赖注入框架的父节点
     */
    InstantiationService.prototype.getParent = function () {
        var _a;
        return (_a = this.hierarchyNode.getParent()) === null || _a === void 0 ? void 0 : _a.getSelfNode();
    };
    /**
     * 将模块动态的添加到当前框架的容器中
     * @param id  模块ID
     * @param instanceOrDescriptor  模块实例或描述符
     * @param append 是否为追加模式
     */
    InstantiationService.prototype.addService = function (id, instanceOrDescriptor, append) {
        if (append) {
            this.innerService.setMulti(id, instanceOrDescriptor);
        }
        else {
            this.innerService.set(id, instanceOrDescriptor);
        }
    };
    /**
     * 使用框架创建模块的实例，首先解析出模块的依赖图，然后按照依赖图依次实例化
     * @param ctorOrDescriptor 构造函数或描述符
     * @param rest 静态参数
     */
    InstantiationService.prototype.createInstance = function (ctorOrDescriptor) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        // 用于跟踪框架注入的trace
        var trace;
        var result;
        if (ctorOrDescriptor instanceof descriptors_1.SyncDescriptor) {
            trace = instantiation_trace_1.InstantiationTrace.traceCreation(ctorOrDescriptor.ctor);
            result = this.resolveAndCreateInstance(ctorOrDescriptor.ctor, ctorOrDescriptor.staticArguments.concat(rest), trace);
        }
        else {
            trace = instantiation_trace_1.InstantiationTrace.traceCreation(ctorOrDescriptor);
            result = this.resolveAndCreateInstance(ctorOrDescriptor, rest, trace);
        }
        trace.stop();
        return result;
    };
    /**
     * 支持外部受限的访问依赖注入框架内部的实例
     * @param fn 回调函数
     * @param args 静态参数
     */
    InstantiationService.prototype.invokeFunction = function (fn) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // 踪依赖注入框架的Trace日志
        var trace = instantiation_trace_1.InstantiationTrace.traceInvocation(fn);
        // 为控制外部对容器内部实例的访问,accessor只能使用一次,不能传递使用
        try {
            var accessor = {
                get: function (id) {
                    // 通过ID获取实例
                    var query = { serviceIdentifier: id, isMultiInject: true };
                    var result = _this.getOrCreateServiceInstance(query, trace);
                    if (!result) {
                        // eslint-disable-next-line new-cap
                        throw new Error(error_messages_1.INVOKE_UNKNOWN_SERVICE(service_identifier_1.getIdentifierName(id)));
                    }
                    return result;
                },
                getAll: function (id) {
                    // 通过ID获取实例
                    var query = { serviceIdentifier: id, isMultiInject: true };
                    var result = _this.getOrCreateServiceInstances(query, trace);
                    if (!result) {
                        // eslint-disable-next-line new-cap
                        throw new Error(error_messages_1.INVOKE_UNKNOWN_SERVICE(service_identifier_1.getIdentifierName(id)));
                    }
                    return result;
                },
            };
            return fn.apply(void 0, __spread([accessor], args));
        }
        finally {
            trace.stop();
        }
    };
    /**
     * 框架的清理方法dispose
     * @param trace
     */
    InstantiationService.prototype.dispose = function (trace, recursive) {
        var _this = this;
        if (recursive === void 0) { recursive = false; }
        // 新建清理树形日志trace
        var parentTrace = trace || dispose_tree_1.DisposeTrace.traceRoot('IInstantiationService');
        // 调用DI框架容器的清理方法dispose
        this.innerService.teardown(
        // InstantiationService为di框架需要特殊处理, 不能dispose
        function (instance) { return instance && !(instance instanceof InstantiationService); }, 
        // DynamicLoader或IdleLoader为异步加载模块的包裹器因此需要特殊处理, 不能reset
        function (instance) { return !(instance instanceof loader_base_1.LoaderBase); }, 
        // InstantiationService为di框架需要特殊处理, 不能delete
        function (instance) { return !(instance instanceof InstantiationService); }, parentTrace);
        // 依次调用子框架的清理方法dispose
        if (!recursive) {
            this.hierarchyNode.walkDown(function (node) {
                if (node !== _this) {
                    node.dispose(parentTrace.branch('IInstantiationService'), true);
                }
            });
        }
        // 清理hook函数
        this.hookRegistry.clear();
        // 清理通用hook
        this.commonHookList = [];
        // trace
        !trace && parentTrace && parentTrace.stop();
    };
    /**
     * 判断DI容器中是否有id对应的服务
     * @param id
     * @returns boolean
     */
    InstantiationService.prototype.has = function (id) {
        var isHas = false;
        this.hierarchyNode.walkUp(function (instantiationNode) {
            if (!isHas) {
                isHas = instantiationNode.innerService.has(id);
            }
        });
        return isHas;
    };
    /**
     * 根据identifier获取服务的class
     * @param serviceIdentifier
     */
    InstantiationService.prototype.getClass = function (serviceIdentifier) {
        var typeCtor;
        this.hierarchyNode.walkUp(function (instantiationNode) {
            var _a;
            if (!typeCtor) {
                var holder = instantiationNode.innerService.getHolder({ serviceIdentifier: serviceIdentifier });
                typeCtor = (_a = holder === null || holder === void 0 ? void 0 : holder.descriptor) === null || _a === void 0 ? void 0 : _a.ctor;
            }
        });
        return typeCtor;
    };
    /**
     * 支持针对特定ID注册hook函数
     */
    InstantiationService.prototype.addHook = function (hookPoint, id, callback) {
        return this.addServiceHook(hookPoint, id, callback);
    };
    /**
     * 添加通用hook函数, 通过filter过滤执行
     * @param hookPoint
     * @param callback
     * @param filter
     */
    InstantiationService.prototype.addCommonHook = function (hookPoint, callback, filter) {
        this.commonHookList.push({
            hookPoint: hookPoint,
            callback: callback,
            filter: filter,
        });
    };
    /**
     * 将两个DI树merge, 同时保持单向可达的访问性要求
     * @param instantiationService
     */
    InstantiationService.prototype.mergeTo = function (instantiationService) {
        this.hierarchyNode.mergeTo(instantiationService.getHierarchyNode());
    };
    InstantiationService.prototype.addServiceHook = function (hookPoint, id, callback) {
        var isHooked = false;
        // 保持hook的单向可达性
        this.hierarchyNode.walkUp(function (instantiationNode) {
            // 只hook一次
            if (!isHooked) {
                if (instantiationNode.innerService.has(id)) {
                    // 处理loader实例化后再添加hook的情况
                    var holders = instantiationNode.innerService.getAllHolder({ serviceIdentifier: id, isMultiInject: true });
                    holders === null || holders === void 0 ? void 0 : holders.forEach(function (holder) {
                        if (holder.instance && util_1.isLoaderHolder(holder.instance)) {
                            util_1.addLoaderHook(holder.instance, hookPoint, callback);
                        }
                    });
                    // 处理普通情况
                    var keyMapping = instantiationNode.innerService.getMapping();
                    var serviceKeys = keyMapping.getMapping(id);
                    serviceKeys.forEach(function (serviceKey) {
                        if (serviceKey && typeof serviceKey !== 'string') {
                            var hooksFn = instantiationNode.hookRegistry.get(serviceKey) || [];
                            hooksFn.push({ hookPoint: hookPoint, callback: callback });
                            instantiationNode.hookRegistry.set(serviceKey, hooksFn);
                            isHooked = true;
                        }
                    });
                }
            }
        });
        return isHooked;
    };
    InstantiationService.prototype.resolveAndCreateInstance = function (ctor, args, trace) {
        var e_1, _a;
        var _b;
        if (args === void 0) { args = []; }
        // 获取ctor上保存的依赖关系, 按index大小递增排序
        var serviceDependencies = dependency_resolver_1.DependencyResolver.getServiceDependencies(ctor).sort(function (a, b) { return a.index - b.index; });
        var serviceArgs = [];
        try {
            // 遍历依赖数组
            for (var serviceDependencies_1 = __values(serviceDependencies), serviceDependencies_1_1 = serviceDependencies_1.next(); !serviceDependencies_1_1.done; serviceDependencies_1_1 = serviceDependencies_1.next()) {
                var dependency = serviceDependencies_1_1.value;
                // 获取所依赖的服务实例，可能触发递归的依赖解析
                var service = dependency.query.isMultiInject
                    ? this.getOrCreateServiceInstances(dependency.query, trace)
                    : this.getOrCreateServiceInstance(dependency.query, trace);
                // 严格模式下，找不到依赖时抛出异常
                if (!service && this.strictMode && !((_b = dependency === null || dependency === void 0 ? void 0 : dependency.query) === null || _b === void 0 ? void 0 : _b.isOption)) {
                    // eslint-disable-next-line new-cap
                    throw new Error(error_messages_1.DEPEND_ON_UNKNOWN_SERVICE(ctor.name, service_identifier_1.getIdentifierName(dependency.id)));
                }
                serviceArgs.push(service);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (serviceDependencies_1_1 && !serviceDependencies_1_1.done && (_a = serviceDependencies_1.return)) _a.call(serviceDependencies_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var alignedArgs = this.alignArgs(args, serviceDependencies);
        // 使用服务化参数和静态参数，调用构造函数，初始化实例
        // eslint-disable-next-line new-cap
        var instance = new (ctor.bind.apply(ctor, __spread([void 0], __spread(alignedArgs, serviceArgs))))();
        this.executePostDecorator(ctor, instance);
        this.executePostHooks(ctor, instance);
        this.executeCommonPostHooks(instance);
        return instance;
    };
    InstantiationService.prototype.executePostHooks = function (ctor, instance) {
        var hooks = this.hookRegistry.get(ctor);
        hooks && hooks.forEach(function (hook) {
            var hookPoint = hook.hookPoint, callback = hook.callback;
            if (hookPoint === instantiation_1.IInstantiationHookPoint.POST_CONSTRUCTOR) {
                // 如果是loader或者holder则不执行当前callback而是将callback传递到真正的服务
                if (instance && util_1.isLoaderHolder(instance)) {
                    util_1.addLoaderHook(instance, hookPoint, callback);
                }
                else {
                    callback(instance);
                }
            }
        });
    };
    InstantiationService.prototype.executeCommonPostHooks = function (instance) {
        // 维护单向可达性
        this.hierarchyNode.walkDown(function (instantiationNode) {
            instantiationNode.commonHookList.forEach(function (hook) {
                var hookPoint = hook.hookPoint, callback = hook.callback, filter = hook.filter;
                if (hookPoint === instantiation_1.IInstantiationHookPoint.POST_CONSTRUCTOR) {
                    if (!filter || filter(instance)) {
                        callback(instance);
                    }
                }
            });
        });
    };
    InstantiationService.prototype.executePostDecorator = function (ctor, instance) {
        // 执行postConstructor钩子函数
        var methodName = util_1.getPostConstructorMethodName(ctor);
        if (methodName) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            instance[methodName].call(instance);
        }
    };
    // 根据非服务化参数的个数校准服务化参数的位置
    InstantiationService.prototype.alignArgs = function (originArgs, serviceDependencies) {
        var alignedArgs = originArgs;
        // 计算服务化参数在模块构造函数中的位置
        var firstServiceArgPos = serviceDependencies.length > 0 ? serviceDependencies[0].index : originArgs.length;
        // 检查参数不匹配的情况
        if (originArgs.length !== firstServiceArgPos) {
            var delta = firstServiceArgPos - originArgs.length;
            if (delta > 0) {
                // 如果没有足够的静态参数，则注入undefined
                alignedArgs = originArgs.concat(new Array(delta));
            }
            else {
                // 如果静态参数个数过多，则从头开始选取所需个数的参数
                alignedArgs = originArgs.slice(0, firstServiceArgPos);
            }
        }
        return alignedArgs;
    };
    InstantiationService.prototype.tryToCacheServiceInstance = function (holder, instance) {
        if ((holder === null || holder === void 0 ? void 0 : holder.descriptor) instanceof descriptors_1.SyncDescriptor) {
            holder.instance = instance;
            return true;
        }
        return false;
    };
    InstantiationService.prototype.getServiceInstanceOrDescriptor = function (query) {
        // 查找当前DI框架的容器
        var holder;
        this.hierarchyNode.walkUp(function (instantiationNode) {
            if (!holder) {
                holder = instantiationNode.innerService.getHolder(query);
            }
        });
        return holder;
    };
    InstantiationService.prototype.getAllServiceInstanceOrDescriptors = function (query) {
        // 查找当前DI框架的容器
        var holders;
        this.hierarchyNode.walkUp(function (instantiationNode) {
            if (!holders) {
                holders = instantiationNode.innerService.getAllHolder(query);
            }
        });
        return holders;
    };
    InstantiationService.prototype.createAndCacheServiceInstance = function (query, desc, trace) {
        // 解析依赖图
        var graph = this.resolveDependencyGraph(query, desc, trace);
        // 根据依赖图初始化实例
        var instance = this.createServiceInstanceFromGraph(graph);
        return instance;
    };
    // 解析依赖图
    InstantiationService.prototype.resolveDependencyGraph = function (query, descriptor, trace) {
        var e_2, _a;
        var _b;
        var graph = new graph_1.Graph({
            hashId: function (data) { return data.query.serviceIdentifier; },
            hashString: function (data) { return service_identifier_1.getIdentifierName(data.query.serviceIdentifier); },
        });
        var cycleCount = 0;
        var stack = [{ query: query, descriptor: descriptor, trace: trace }];
        while (stack.length) {
            var item = stack.pop();
            graph.lookupOrInsertNode(item);
            // 循环次数过多表示有循环依赖
            if (cycleCount > 1000) {
                throw new typing_1.CyclicDependencyError(graph);
            }
            cycleCount += 1;
            var dependencies = dependency_resolver_1.DependencyResolver.getServiceDependencies(item.descriptor.ctor);
            try {
                // 根据构造函数存储的依赖关系生成模块依赖图
                for (var dependencies_1 = (e_2 = void 0, __values(dependencies)), dependencies_1_1 = dependencies_1.next(); !dependencies_1_1.done; dependencies_1_1 = dependencies_1.next()) {
                    var dependency = dependencies_1_1.value;
                    // 处理multi injection
                    var holders = this.getAllServiceInstanceOrDescriptors(dependency.query);
                    if (!holders && !((_b = dependency === null || dependency === void 0 ? void 0 : dependency.query) === null || _b === void 0 ? void 0 : _b.isOption)) {
                        // eslint-disable-next-line new-cap
                        console.warn(error_messages_1.CREATE_INSTANCE_NOT_REGISTERED(service_identifier_1.getIdentifierName(query.serviceIdentifier), service_identifier_1.getIdentifierName(dependency.id)));
                    }
                    var holderItems = holders === null || holders === void 0 ? void 0 : holders.filter(function (holderItem) { return holderItem.descriptor; });
                    if (holderItems && (holderItems === null || holderItems === void 0 ? void 0 : holderItems.length) > 0 && holderItems[0].descriptor) {
                        var deps = {
                            query: dependency.query,
                            descriptor: holderItems[0].descriptor,
                            trace: item.trace.branch(dependency.id, true),
                        };
                        graph.insertEdge(item, deps);
                        stack.push(deps);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (dependencies_1_1 && !dependencies_1_1.done && (_a = dependencies_1.return)) _a.call(dependencies_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return graph;
    };
    // 根据依赖图实例化对象
    InstantiationService.prototype.createServiceInstanceFromGraph = function (graph) {
        var e_3, _a;
        var instance;
        var ctor;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            var roots = graph.roots();
            // 图中存在循环依赖
            if (roots.length === 0) {
                if (!graph.isEmpty()) {
                    throw new typing_1.CyclicDependencyError(graph);
                }
                break;
            }
            try {
                // 对图的叶子节点进行实例化
                for (var roots_1 = (e_3 = void 0, __values(roots)), roots_1_1 = roots_1.next(); !roots_1_1.done; roots_1_1 = roots_1.next()) {
                    var data = roots_1_1.value.data;
                    ctor = data.descriptor.ctor;
                    instance = this.createServiceInstanceWithOwner(data.query, data.descriptor.ctor, data.descriptor.staticArguments, data.descriptor.supportsDelayedInstantiation, data.trace);
                    // 删除实例化后的叶子节点
                    graph.removeNode(data);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (roots_1_1 && !roots_1_1.done && (_a = roots_1.return)) _a.call(roots_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (!instance) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.RESOLVE_UNKNOWN_SERVICE(ctor === null || ctor === void 0 ? void 0 : ctor.name));
        }
        return instance;
    };
    InstantiationService.prototype.getOrCreateServiceInstance = function (query, trace) {
        var _a;
        var holder = this.getServiceInstanceOrDescriptor(query);
        if (!(holder === null || holder === void 0 ? void 0 : holder.instance) && (holder === null || holder === void 0 ? void 0 : holder.descriptor)) {
            return this.createAndCacheServiceInstance(query, holder.descriptor, trace.branch(query.serviceIdentifier, true));
        }
        if (!instantiation_trace_1.InstantiationTrace.traverse(trace, query.serviceIdentifier, false)) {
            trace.branch(query.serviceIdentifier, false);
        }
        return (_a = holder === null || holder === void 0 ? void 0 : holder.instance) !== null && _a !== void 0 ? _a : undefined;
    };
    InstantiationService.prototype.getOrCreateServiceInstances = function (query, trace) {
        var _this = this;
        var holders = this.getAllServiceInstanceOrDescriptors(query);
        var instances = [];
        holders === null || holders === void 0 ? void 0 : holders.forEach(function (holder) {
            if (holder.instance) {
                instances.push(holder.instance);
            }
            else if (holder.descriptor) {
                var instance = _this.createAndCacheServiceInstance(query, holder.descriptor, trace.branch(query.serviceIdentifier, true));
                instances.push(instance);
            }
            if (!instantiation_trace_1.InstantiationTrace.traverse(trace, query.serviceIdentifier, false)) {
                trace.branch(query.serviceIdentifier, false);
            }
        });
        return instances || undefined;
    };
    InstantiationService.prototype.createServiceInstanceWithOwner = function (query, ctor, args, supportsDelayedInstantiation, trace) {
        var _this = this;
        if (args === void 0) { args = []; }
        var instance;
        // 递归的使用父DI框架创建模块实例
        this.hierarchyNode.walkUp(function (instantiationNode) {
            var _a;
            if (instance) {
                return;
            }
            // multiInject模式下需要过滤
            var holders = instantiationNode.innerService.getAllHolder(query, function (holder) { var _a; return ((_a = holder.descriptor) === null || _a === void 0 ? void 0 : _a.ctor) === ctor; });
            var holder = holders === null || holders === void 0 ? void 0 : holders[0];
            instance = (_a = holder === null || holder === void 0 ? void 0 : holder.instance) !== null && _a !== void 0 ? _a : undefined;
            if (instance) {
                return;
            }
            if (holder === null || holder === void 0 ? void 0 : holder.descriptor) {
                instance = instantiationNode.createServiceInstance(ctor, args, supportsDelayedInstantiation, trace);
                _this.tryToCacheServiceInstance(holder, instance);
            }
        });
        // 遍历完成后依然没有生存实例
        if (instance) {
            return instance;
        }
        // eslint-disable-next-line new-cap
        throw new Error(error_messages_1.CREATING_UNKNOWN_SERVICE(ctor.name));
    };
    InstantiationService.prototype.createServiceInstance = function (ctor, args, supportsDelayedInstantiation, trace) {
        var _this = this;
        if (args === void 0) { args = []; }
        // 如果不支持延迟初始化，则立即创建实例
        if (!supportsDelayedInstantiation || !IS_SUPPORT_PROXY) {
            return this.resolveAndCreateInstance(ctor, args, trace);
        }
        // 延迟初始化策略: 在被注入到依赖对象时不初始化,而是返回一个Proxy,真正使用服务时(调用方法或获取属性)再实例化
        var proxyValue = new proxy_value_1.ProxyValue(function () { return _this.resolveAndCreateInstance(ctor, args, trace); });
        return new Proxy(Object.create(null), {
            get: function (target, key) {
                if (key in target) {
                    return target[key];
                }
                var obj = proxyValue.value;
                var prop = obj[key];
                if (typeof prop !== 'function') {
                    return prop;
                }
                prop = prop.bind(obj);
                target[key] = prop;
                return prop;
            },
            set: function (target, p, value) {
                proxyValue.value[p] = value;
                return true;
            },
        });
    };
    return InstantiationService;
}());
exports.InstantiationService = InstantiationService;
//# sourceMappingURL=instantiation-service.js.map